import { ShoppingCart, Check } from 'lucide-react';
import { useCart, formatAUD } from '@/context/CartContext';

export default function AddToCartButton({ product, variant = 'default' }) {
  const { items, add, openDrawer } = useCart();
  const inCart = items.some((i) => i.product_id === product.id);
  const compact = variant === 'compact';
  const unitLabel = product.unit === 'kg' ? '/kg' : product.unit === 'pack' ? '/pack' : '/ea';

  const onClick = () => (inCart ? openDrawer() : add(product));

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={`add-to-cart-${product.id}`}
      aria-label={inCart ? `${product.name} in cart` : `Add ${product.name} to cart`}
      className={`inline-flex items-center justify-center gap-1.5 uppercase tracking-[0.22em] transition-colors border font-medium ${
        inCart
          ? 'border-emerald-500 text-emerald-400 bg-emerald-500/10 hover:bg-emerald-500 hover:text-white'
          : 'border-[var(--mw-primary)] bg-[var(--mw-primary)] text-white hover:bg-[var(--mw-primary-hover)]'
      } ${compact ? 'text-[10px] px-2.5 py-1.5' : 'text-[11px] px-3.5 py-2'}`}
    >
      {inCart ? <Check size={compact ? 10 : 12} /> : <ShoppingCart size={compact ? 10 : 12} />}
      {inCart ? 'In cart' : `Buy · ${formatAUD(product.price)}${unitLabel}`}
    </button>
  );
}
